import { max, min } from "date-fns"

export function getModelSettings(model) {
  // OpenAI
  if (model === "openai__o3"
    || model === "openai__o4_mini"
    || model === "openai__gpt_4_1"
    || model === "openai__gpt_4_1_mini"
    || model === "openai__gpt_4o"
    || model === "openai__gpt_4o_mini"
    || model === "azure__openai__gpt_4_1"
    || model === "azure__openai__gpt_4_1_mini"
    || model === "azure__openai__gpt_4o"
    || model === "azure__openai__gpt_4o_mini"
    || model === "azure__text_embedding_ada_002"
  ) {
    return OpenAISettings
  }
  // Google Gemini
  if (model === "google__gemini_2_5_pro_preview"
    || model === "google__gemini_2_5_flash_preview"
    || model === "google__gemini_2_0_flash_lite_preview"
    || model === "google__gemini_2_0_flash_001"
    || model === "google__gemini_1_5_pro_001"
    || model === "google__gemini_1_5_flash_001"
    || model === "google__gemini_pro"
  ) {
    return GoogleSettings
  }
  // AWS Claude & Titan
  if (model === "aws__claude_4_sonnet"
    || model === "aws__claude_4_opus"
    || model === "aws__claude_3_7_sonnet"
    || model === "aws__claude_3_5_sonnet"
    || model === "aws__claude_3_sonnet"
    || model === "aws__claude_3_haiku"
    || model === "aws__titan_text_lite"
  ) {
    return AWSSettings
  }
  // IBM
  if (model === "ibm__llama_4_scout"
    || model === "ibm__llama_3_2_90b_vision_instruct"
    || model === "meta__llama_70b"
  ) {
    return IBMSettings
  }
  // xAI
  if (model === "xai__grok_3_beta"
    || model === "xai__grok_3_mini_reasoning_beta"
  ) {
    return XAISettings
  }
}

const OpenAISettings = {
  type: "openai_params",
  temperature: 0.0,
  top_p: 1.0,
  frequency_penalty: 1.5,
  presence_penalty: 1.5,
  stop: "<|im_end|>",
  min_temperature: 0.0,
  max_temperature: 2.0,
  min_top_p: 0.1,
  max_top_p: 1.0,
  min_freq_pen: -2.0,
  max_freq_pen: 2.0,
  min_pres_pen: -2.0,
  max_pres_pen: 2.0,
}

const AWSSettings = {
  type: "aws_params",
  temperature: 0.0,
  top_p: 1.0,
  min_temperature: 0.0,
  max_temperature: 1.0,
  min_top_p: 0.0,
  max_top_p: 1.0,
}

const GoogleSettings = {
  type: "google_params",
  temperature: 0.0,
  top_p: 1.0,
  top_k: 1,
  min_temperature: 0.0,
  max_temperature: 2.0,
  min_top_p: 0.1,
  max_top_p: 2.0,
  min_top_k: 0.1,
  max_top_k: 2,
}

const IBMSettings = {
  type: "ibm_params",
  temperature: 0.0,
  top_p: 0,
  top_k: 50,
  min_temperature: 0.0,
  max_temperature: 1.0,
  min_top_p: 0.1,
  max_top_p: 1.0,
  min_top_k: 0.1,
  max_top_k: 2,
}

const XAISettings = {
  type: "xai_params",
  temperature: 0.0,
  top_p: 1.0,
  frequency_penalty: -1,
  presence_penalty: -1,
  stop: '<|im_end|>',
  min_temperature: 0.0,
  max_temperature: 2.0,
  min_top_p: 0.1,
  max_top_p: 1.0,
  min_freq_pen: -2.0,
  max_freq_pen: 2.0,
  min_pres_pen: -2.0,
  max_pres_pen: 2.0,
}
